export const GetAllEntities = () => {
    const datas_entities = [];
    const datas_attributes = [];
    const datas_describes = [];
    const entities = require.context('../Form/Entities', true);
    const attributes = require.context('../Form/Attributes', true);
    const describes = require.context('../Form/Describes', true);
    entities.keys()
        .filter(el => !el.includes('.js'))
        .map((file) => {
            datas_entities.push(file.slice(2,file.length).toLowerCase());
            return datas_entities;
    });
    attributes.keys()
        .filter(el => !el.includes('.js'))
        .map((file) => {
            datas_attributes.push(file.slice(2,file.length).toLowerCase());
            return datas_attributes;
    });
    describes.keys()
        .filter(el => !el.includes('.js'))
        .map((file) => {
            datas_describes.push(file.slice(2,file.length).toLowerCase());
            return datas_describes;
    });
    return [
        datas_entities,
        datas_attributes,
        datas_describes,
    ];
}